// extracted by mini-css-extract-plugin
export default {"check-mail-inbox":"CheckMailInbox_check-mail-inbox__mH1Wv","card":"CheckMailInbox_card__quwO5","help":"CheckMailInbox_help__lYEz+","icon":"CheckMailInbox_icon__+xFM8"};